module.exports = __webpack_public_path__ + "static/media/ZAdark.0f73f8fe.svg";